// document.addEventListener("DOMContentLoaded", function() {
//     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//     const desktopButtonsContainer = document.querySelectorAll('.cs-buttons');
//     const downloadApp = document.getElementById('download-app');
    
//     const playStore = "#"; //{{ play_store_link | escape }}
//     const appStore = "#"; //{{ app_store_link | escape }}
    
//     const highlightClass = 'bg-[#6068F9] hover:bg-[#565EE0]';
//     const secondaryClass = 'bg-[#23275D] hover:bg-[#191B41]';

//     const btnMac = (highlight) => `<a href="#" class="rounded-full ${highlight ? highlightClass : secondaryClass} text-white font-medium flex gap-2 items-center transition-all duration-300 ease-in-out"><span>Mac</span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M18 5C18.5305 5 19.0392 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V15.526C19.9999 15.8374 20.0725 16.1446 20.212 16.423L21.28 18.55C21.3571 18.703 21.3936 18.8732 21.386 19.0444C21.3784 19.2155 21.327 19.3818 21.2366 19.5274C21.1463 19.6729 21.0201 19.7928 20.8701 19.8756C20.7201 19.9584 20.5513 20.0012 20.38 20H3.62002C3.44871 20.0012 3.27997 19.9584 3.12997 19.8756C2.97997 19.7928 2.85374 19.6729 2.7634 19.5274C2.67305 19.3818 2.62162 19.2155 2.61402 19.0444C2.60643 18.8732 2.64293 18.703 2.72002 18.55L3.78802 16.423C3.92756 16.1446 4.00016 15.8374 4.00002 15.526V7C4.00002 6.46957 4.21073 5.96086 4.58581 5.58579C4.96088 5.21071 5.46959 5 6.00002 5H18Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
// <path d="M20.054 15.987H3.94604" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>
// </a>`;
//     const btnWindows = (highlight) => `<a href="#" class="rounded-full ${highlight ? highlightClass : secondaryClass} text-white font-medium flex gap-2 items-center transition-all duration-300 ease-in-out"><span>Windows</span>🖥️</a>`;
//     const btnIphone = `<a href="${appStore}" class="rounded-full ${secondaryClass} text-white font-medium flex gap-2 items-center"><span>iPhone</span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
// <path d="M12 18H12.01" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>
// </a>`;
//     const btnAndroid = `<a href="${playStore}" class="rounded-full ${secondaryClass} text-white font-medium flex gap-2 items-center transition-all duration-300 ease-in-out"><span>Android</span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
// <path d="M12 18H12.01" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>
// </a>`;

//     let isMac = /Mac/i.test(userAgent);
//     let isWindows = /Win/i.test(userAgent);
//     let buttonsHTML = '';

//     if (isMac) {
//         buttonsHTML = btnMac(true) + btnIphone + btnAndroid;
//     } else if (isWindows) {
//         buttonsHTML = btnWindows(true) + btnIphone + btnAndroid;
//     } else {
//         // Fallback for Linux/Other Desktop
//         buttonsHTML = btnMac(true) + btnIphone + btnAndroid; 
//     }
    
//     desktopButtonsContainer.forEach((btnct)=>{
//     btnct.innerHTML = buttonsHTML;
//     });

//     if (/android/i.test(userAgent)) {
//       downloadApp.href = playStore;
//     } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
//       downloadApp.href = appStore;
//     } else {
//       downloadApp.href = "#";
//     }
//   });



  document.addEventListener("DOMContentLoaded", function () {
  const containerParent = document.querySelectorAll(".download-buttons");

  containerParent.forEach((container) => {
    const appStore = container.dataset.appstore || "#";
    const playStore = container.dataset.playstore || "#";
    const macStore = container.dataset.mac || "#";
    const windowStore = container.dataset.windows || "#";

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let detected = "Mac";
    if (/windows/i.test(userAgent)) detected = "Windows";
    else if (/android/i.test(userAgent)) detected = "Android";
    else if (/iPad|iPhone|iPod/.test(userAgent)) detected = "iPhone";

    const buttons = [
      {
        name: "Mac",
        icon: `<svg class="w-5 h-5" viewBox="0 0 24 24" fill="none"><path d="M18 5C18.53 5 19.04 5.21 19.41 5.59C19.79 5.96 20 6.47 20 7V15.53C20 15.84 20.07 16.14 20.21 16.42L21.28 18.55C21.36 18.7 21.39 18.87 21.39 19.04C21.38 19.22 21.33 19.38 21.24 19.53C21.15 19.67 21.02 19.79 20.87 19.88C20.72 19.96 20.55 20 20.38 20H3.62C3.45 20 3.28 19.96 3.13 19.88C2.98 19.79 2.85 19.67 2.76 19.53C2.67 19.38 2.62 19.22 2.61 19.04C2.61 18.87 2.64 18.7 2.72 18.55L3.79 16.42C3.93 16.14 4 15.84 4 15.53V7C4 6.47 4.21 5.96 4.59 5.59C4.96 5.21 5.47 5 6 5H18Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.05 15.99H3.95" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        link: macStore,
      },
      {
        name: "Windows",
        icon: `<svg class="w-5 h-5" viewBox="0 0 24 24" fill="none"><path d="M18 5C18.53 5 19.04 5.21 19.41 5.59C19.79 5.96 20 6.47 20 7V15.53C20 15.84 20.07 16.14 20.21 16.42L21.28 18.55C21.36 18.7 21.39 18.87 21.39 19.04C21.38 19.22 21.33 19.38 21.24 19.53C21.15 19.67 21.02 19.79 20.87 19.88C20.72 19.96 20.55 20 20.38 20H3.62C3.45 20 3.28 19.96 3.13 19.88C2.98 19.79 2.85 19.67 2.76 19.53C2.67 19.38 2.62 19.22 2.61 19.04C2.61 18.87 2.64 18.7 2.72 18.55L3.79 16.42C3.93 16.14 4 15.84 4 15.53V7C4 6.47 4.21 5.96 4.59 5.59C4.96 5.21 5.47 5 6 5H18Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.05 15.99H3.95" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        link: windowStore,
      },
      {
        name: "iPhone",
        icon: `<svg class="w-5 h-5" viewBox="0 0 24 24" fill="none"><path d="M17 2H7C5.9 2 5 2.9 5 4v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 18h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        link: appStore,
      },
      {
        name: "Android",
        icon: `<svg class="w-5 h-5" viewBox="0 0 24 24" fill="none"><path d="M17 2H7C5.9 2 5 2.9 5 4v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 18h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        link: playStore,
      },
    ];

    const primary =
      "bg-[#6068F9] text-white text-[20px] tracking-[-0.02em] hover:bg-[#565EE0] leading-[1.4] border border-[#6068F9]";
    const secondary =
      "bg-transparent text-[#23275D] text-[16px] tracking-[-0.02em] leading-[1.4] border border-[#D3D3DF] hover:bg-[#f1f3ff]";

    const detectedButton = buttons.find((b) => b.name === detected);
    const otherButtons = buttons.filter((b) => b.name !== detected);

    if (true) {
      container.innerHTML = `
        <a href="${detectedButton.link}" target="_blank" 
           class="featured_btn px-8 py-[18px] rounded-full font-medium flex items-center justify-center gap-2 transition-all duration-300 ${primary}">
          <span>Download for ${detectedButton.name}</span>
          ${detectedButton.icon}
        </a>
        <div class="other_buttons flex flex-wrap justify-start max-md:justify-center gap-2">
          ${otherButtons
            .map(
              (b) => `
              <a href="${b.link}" target="_blank"
                 class="px-6 py-[9px] rounded-full font-medium flex items-center justify-center gap-2 transition-all duration-300 ${secondary}">
                <span>${b.name}</span>
                ${b.icon}
              </a>`
            )
            .join("")}
        </div>
      `;
    } else {
      container.innerHTML = `
        <a href="${detectedButton.link}" target="_blank" 
           class="featured_btn px-8 py-[18px] rounded-full font-medium flex items-center justify-center gap-2 transition-all duration-300 ${primary}">
          <span>Download the app</span>
          ${detectedButton.icon}
        </a>
      `;
    }
  });
});
